import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PlugsConnected, CheckCircle } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "@/lib/api";

export const PaypalWebhookCard = () => {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const origin = window.location.origin;

  useEffect(() => {
    api.get("/admin/paypal/webhook", { params: { origin } }).then((r) => setState(r.data)).catch(() => setState({ error: true }));
  }, [origin]);

  const connect = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/paypal/webhook", { origin });
      setState(r.data);
      toast.success("PayPal updates connected for this website.");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not connect PayPal updates.");
    } finally { setBusy(false); }
  };

  if (!state || state.error) return null;
  return (
    <div data-testid="paypal-webhook-card" className="mt-6 flex flex-col gap-3 rounded-2xl border border-[#4A4540]/10 bg-white p-5 sm:flex-row sm:items-center">
      {state.connected ? <CheckCircle size={26} weight="fill" className="text-[#2F6B3A]" /> : <PlugsConnected size={26} weight="duotone" className="text-[#E06D53]" />}
      <div className="flex-1">
        <p data-testid="paypal-webhook-status" className="font-semibold text-[#2C2A28]">
          PayPal {state.mode === "live" ? "Live" : "Sandbox"} updates: {state.connected ? "connected" : "not connected yet"}
        </p>
        <p className="text-sm text-[#8A7F76]">Lets PayPal tell this site about pending payments, refunds and disputes automatically.</p>
      </div>
      {!state.connected && (
        <button data-testid="paypal-webhook-connect-btn" onClick={connect} disabled={busy}
          className="rounded-full bg-[#E06D53] px-6 py-3 text-sm font-semibold text-white hover:bg-[#C95A42] disabled:opacity-50">
          {busy ? "Connecting…" : "Connect PayPal updates"}
        </button>
      )}
    </div>
  );
};
